module.exports = require("./lib/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-core/polyfill.js
 ** module id = 587
 ** module chunks = 0 1 4 5 6 7 8
 **/